import { Outlet, useLocation } from 'react-router-dom';
import { useLayoutEffect } from 'react';

const ReportLayout = () => {
  const location = useLocation();

  useLayoutEffect(() => {
    // This effect runs every time the location (route) changes.
    // We use useLayoutEffect to prevent a visual "flash" of the old scroll position.
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'auto', // 'auto' for instant scroll, 'smooth' for animated scroll
    });
  }, [location.pathname]); // Depend on the pathname to trigger on navigation

  return (
    <div className="relative min-h-screen bg-background">
      <main className="pb-6">
        <Outlet />
      </main>
    </div>
  );
};

export default ReportLayout;